import Vue from 'vue';
Vue.use(require('vue-cookies'))

export function isAuth() {
  const user = Vue.$cookies.get('user')
  const token = Vue.$cookies.get('token')
  if (user && user.token && user.token === token) {
    return true
  }
  return false;
}
export function getUser() {
  return Vue.$cookies.get('user');
}

export function isSuperAdmin() {
  const user = Vue.$cookies.get('user');
  return !!(user && (user._id === "66857a6a9ee74d2bc8f41ee7" || user._id === "668b5c597b3423515c927701" || user._id === "664da1730083a030987d0265"));
}
